export const TagDT = {
	tag: {
		css: ({ dt }) => `
          .p-tag-font-normal {
              .p-tag-label {
                  font-weight: 500;
                  font-size: 0.6875rem;
                  line-height: 1rem;
                  letter-spacing: 0;
              }
          }
        `,
	},
};
